<template>
  <div style="position: relative">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <Info ref="info" :show="false" :row="row" style="height: 340px; overflow: auto"></Info>
    <Card style="padding-bottom: 10px">
      <div slot="title">
        <Form inline>
          <FormItem> {{ $t("bindFreight") + $t("information") }}</FormItem>
          <FormItem v-if="hasPermission(200)">
            <Button type="error" @click="deleteClick" icon="md-trash" :disabled="!selectArr.length">
              {{ $t("delete") }}
            </Button>
          </FormItem>
          <FormItem v-if="hasPermission(202)">
            <Button type="success" @click="exportExc" icon="md-download">
              {{ $t("Export Details") }}
            </Button>
          </FormItem>
          <FormItem v-if="hasPermission(557)">
            <Upload :before-upload="handleUpload" action="" class="info-btn">
              <Button icon="ios-cloud-upload-outline">
                {{ filePath ? $t("update") : $t("updateFile")
                }}{{ $t("bindFreight") }}
              </Button>
            </Upload>
          </FormItem>
          <FormItem v-if="filePath && hasPermission(203)">
            <Button type="primary" @click="preview($globalUrl + filePath)">
              {{ $t("preview") }}{{ $t("bindFreight") }}
            </Button>
          </FormItem>
          <FormItem>
            <Select v-model="defId" :placeholder="$t('choose price')" transfer filterable filter-by-label>
              <Option v-for="item in defList" :value="item.value" :key="item.value" :label="item.label"
                @click.native="SearchSubmit(item)"></Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="toPath">
              {{
                $t(defId == 0 ? "setup the fixed price" : "Skip quote details")
              }}
            </Button>
          </FormItem>
          <!-- <FormItem> {{ $t("special_remark") }}: </FormItem> -->
          <FormItem>
            <!-- <Input
              v-model="finance_remarks"
              :placeholder="$t('enter') + $t('special_remark')"
							type="textarea"
							:rows="2"
            >
            </Input> -->
            <Button type="primary" @click="remark">
              {{ $t("special_remark") }}
            </Button>
          </FormItem>
          <FormItem v-if="hasPermission(1150)">
            <Button :type="
              (row.target_type == 2
                ? row.branch_finance_time
                : row.finance_time) > 0
                ? 'error'
                : 'primary'
            " @click="comfirm">
              {{
                (
                  row.target_type == 2
                    ? row.branch_finance_time
                    : row.finance_time
                )
                ? $t("cancel")
                : $t("order_submit")
              }}{{ $t("bindFreight") }}
            </Button>

            <Button :style="{marginLeft: '10px'}" @click="comfirm2">
              生成账单
            </Button>
          </FormItem>
        </Form>
      </div>
      <Table :columns="tableTitle" :data="tableData" border stripe @on-selection-change="selectTable" ref="selection"
        height="300">
        <template v-for="(item, len) in tableTitle" :slot="item.slot" slot-scope="{ row, index }">
          <template v-if="item.button">
            <Button v-if="hasPermission(198)" type="warning" @click="addClick" size="small" style="margin-right: 5px"
              :key="len">
              <Icon type="md-add"></Icon>
            </Button>
            <Button @click="deleteItem(index)" size="small" :key="item.button" :disabled="tableData.length == 1">
              <Icon type="md-trash"></Icon>
            </Button>
          </template>
          <InputNumber v-else-if="item.inputNumber" v-model="tableData[index][item.slot]" :key="len" :step="0.0001"
            @on-blur="changPrice(index, item.slot)">
          </InputNumber>
          <Input v-else-if="item.input" v-model="tableData[index][item.slot]" :key="len"></Input>
          <Select v-model="tableData[index][item.slot]" v-else-if="item.select" transfer :key="len"
            @on-change="changeCategory(index, item.slot)" filterable filter-by-label>
            <template v-if="item.slot == 'expense_item'">
              <Option v-for="key in itemList" :value="key.value" :key="key.value" :label="key.label"></Option>
            </template>
            <template v-else-if="item.slot == 'unit_name'">
              <Option v-for="key in chargingList" :value="key.value" :key="key.value" :label="key.label"></Option>
            </template>
            <template v-else-if="item.slot == 'currency'">
              <Option v-for="key in currencyList" :value="key.value" :key="key.value" :label="key.label"></Option>
            </template>
            <template v-else>
              <Option v-for="key in categoryList" :value="key.id" :key="key.id" :label="key.name"></Option>
            </template>
          </Select>
        </template>
      </Table>
      <div class="total-bill">
        <div class="label">
          <template v-if="costingTips">
            预计成本参考: <span style="color: red;">{{costingTips}}。</span>
            <span style="color: #0aaeb3;">请注意核对!!!</span>
          </template>
          {{ $t("total") }}:</div>
        <div class="label">
          <div class="titel">
            {{ $t("bindFreight") }}:<span>{{ totalData.total }}</span>{{ $t("items") }}
          </div>
          <div class="titel">
            CNY：<span>{{ totalData.cny }}</span>
          </div>
          <div class="titel">
            USD：<span>{{ totalData.usd }}</span>
          </div>
          <div class="titel">
            SAR<span>{{ totalData.sar ? totalData.sar : 0 }}</span>
          </div>
          <div class="titel">
            AED：<span>{{ totalData.aed ? totalData.aed : 0 }}</span>
          </div>
          <div class="titel">
            QAR：<span>{{ totalData.qar ? totalData.qar : 0 }}</span>
          </div>
          <div class="titel">
            KWD：<span>{{ totalData.kwd ? totalData.kwd : 0 }}</span>
          </div>
          <div class="titel">
            BHD：<span>{{ totalData.bhd ? totalData.bhd : 0 }}</span>
          </div>
          <div class="titel">
            <Button type="primary" size="small" @click="save">{{
              $t("save")
            }}</Button>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>
<script>
import {
  getDoubleBill,
  getDoubleContents,
  getItem,
  saveDoubleBill,
  delBill,
  updateBill,
  fileRead,
  getCharging,
  getChargingType,
  exportBillDetails,
  getDefList,
  getFinanceData,
  batchSaveFinance,
  confirmedFinance, getSystemCosting, makePaymentBill,
} from "@/api/double/list";
import { getB2bCategory } from "@/api/storage/category";
import Info from "./info.vue";

export default {
  inject: ["$page"],
  components: {
    Info,
  },
  props: {
    row: {
      type: Object,
    },
    close: {
      type: Function,
    },
  },
  data() {
    return {
      totalData: {},
      finance_remarks: "",
      categoryList: [],
      currency: "",
      type: "IN",
      tableData: [],
      total: 0,
      loading: true,
      title: "新增费用",
      ruleFrom: {
        cate_id: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change",
          },
        ],
        expense_item: [
          {
            required: true,
            type: "number",
            message: "cannot be empty",
            trigger: "change",
          },
        ],
        currency: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "change",
          },
        ],
        unit_name: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur",
          },
        ],
        remarks: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "change",
          },
        ],
      },
      conmanyList: [],
      itemList: [],
      itemText: "",
      text: "",
      selectArr: [],
      width: 600,
      preForm: {},
      currencyList: [
        { label: "人民币-CNY", value: "CNY" },
        { label: "美元-USD", value: "USD" },
        { label: "沙特币-SAR", value: "SAR" },
        { label: "迪拉姆-AED", value: "AED" },
        { label: "卡塔尔里亚尔-QAR", value: "QAR" },
        { label: "科威特第纳尔-KWD", value: "KWD" },
        { label: "巴林蒂娜-BHD", value: "BHD" },
      ],
      filePath: "",
      chargingList: [],
      objOther: {},
      defList: [],
      defId: 0,
      costingTips: ''
    };
  },
  computed: {
    tableTitle() {
      let columns = [];

      columns.push({
        type: "selection",
        width: 60,
        align: "center",
      });

      columns.push({
        key: "index",
        width: 70,
        align: "center",
        title: this.$t("serial_number"),
      });
      columns.push({
        title: this.$t("operate"),
        key: "operator_name",
        align: "center",
        width: 100,
        tooltip: "true",
      });
      columns.push({
        title: this.$tz("操作时间"),
        key: "create_time",
        align: "center",
        width: 100,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("company"),
        key: "service_name",
        align: "center",
        width: 115,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("category") + this.$t("reuiqre2"),
        slot: "cate_id",
        minWidth: 100,
        select: true,
        tooltip: "true",
        className: "text-left",
      });
      columns.push({
        title: this.$t("expense_item") + this.$t("reuiqre2"),
        slot: "expense_item",
        minWidth: 100,
        tooltip: "true",
        select: true,
        className: "text-left",
      });
      columns.push({
        title: this.$t("expType") + this.$t("reuiqre2"),
        slot: "unit_name",
        minWidth: 100,
        select: true,
        className: "text-left",
      });
      columns.push({
        title: this.$t("Billing") + this.$t("number"),
        key: "charging_value",
        minWidth: 80,
        className: "text-left",
      });
      columns.push({
        title: this.$t("doublePrice") + this.$t("reuiqre2"),
        align: "center",
        width: 110,
        slot: "price",
        inputNumber: true,
      });
      columns.push({
        title: this.$t("currencyCode") + this.$t("reuiqre2"),
        align: "center",
        minWidth: 100,
        slot: "currency",
        select: true,
        className: "text-left",
      });
      columns.push({
        title: this.$t("doubleAmount"),
        align: "center",
        key: "total_amount",
        width: 120,
      });
      columns.push({
        title: this.$t("order_desc"),
        align: "center",
        tooltip: "true",
        slot: "remarks",
        minWidth: 95,
        input: true,
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        width: 120,
        button: true,
      });
      return columns;
    },
  },
  mounted() {
    // this.SearchSubmit();
    this.getOtherList();
  },
  methods: {
    init() {
      this.$refs["info"].init();
    },
    remark() {
      this.$page
        .getModal("batchSetRemarks")
        .open({ ids: [this.row.id], type: 2 }, function () {
          this.setTitle(this.$t("setting") + this.$t("Remarks"));
        });
    },
    comfirm() {
      confirmedFinance({
        airway_number: this.row.airway_number,
        type:
          (this.row.target_type == 2
            ? this.row.branch_finance_time
            : this.row.finance_time) > 0
            ? "NO"
            : "YES",
        target_type: this.row.target_type,
        withBill: false,
      }).then((res) => {
        if (res.data.status) {
          this.$Message.success("success");
          this.$page.getList();
          this.close();
        }
      });
    },
    comfirm2() {
      makePaymentBill({
        airway_number: this.row.airway_number,
      }).then((res) => {
        if (res.data.status) {
          this.$Message.success("success");
          this.$page.getList();
          this.close();
        }
      });
    },
    toPath() {
      this.close();
      this.$router.push({
        name: "b2b_feright",
      });
      if (this.defId != 0) {
        let obj = {};
        this.defList.forEach((item) => {
          if (item.value == this.defId) {
            obj = item;
          }
        });
        this.$store.dispatch("pageUrl", obj);
      }
    },
    save() {
      let data = {
        airway_number: this.row.airway_number,
        finance: this.tableData,
        finance_remarks: this.finance_remarks,
        target_type: this.row.target_type,
      };
      batchSaveFinance(data).then((res) => {
        this.alertMes(res);
      });
    },
    hasPermission(id) {
      return this.$hasPermission(id);
    },
    deleteClick() {
      this.$Modal.confirm({
        title: this.$t("delete"),
        width: 300,
        content: this.$t("titleModal"),
        onOk: () => {
          delBill(this.row.airway_number, {
            id: this.selectArr,
            target_type: this.row.target_type,
          }).then((res) => {
            this.alertMes(res);
          });
        },
      });
    },
    deleteItem(index) {
      this.$Modal.confirm({
        title: this.$t("delete"),
        width: 300,
        content: this.$t("titleModal"),
        onOk: () => {
          this.tableData.splice(index, 1);
        },
      });
    },
    addClick() {
      this.tableData.unshift({
        cate_id: "",
        expense_item: 0,
        charging_value: 0,
        price: 0,
        remarks: "",
        total_amount: "",
        currency: "",
      });
      // if (
      //   !row.cate_id ||
      //   !row.unit_name ||
      //   !row.expense_item ||
      //   !row.currency
      // ) {
      //   this.$Message["error"]({
      //     background: true,
      //     content: "请输入必填项",
      //     duration: 5
      //   });
      //   return;
      // }
      // this.addList(row);
    },
    // updateClick(row) {
    //   let data = {
    //     cate_id: row.cate_id,
    //     expense_item: row.expense_item,
    //     unit_name: row.unit_name,
    //     price: row.price,
    //     remarks: row.remarks,
    //     finance_id: row.id,
    //     currency: row.currency
    //   };
    //   saveDoubleBill(this.row.airway_number, data).then(res => {
    //     this.alertMes(res);
    //   });
    // },
    changPrice(index, type) {
      this.changeCategory(index, type);
    },
    changeCategory(index, type) {
      if (type != "expense_item" && this.tableData[index].cate_id) {
        getCharging(this.row.airway_number, this.tableData[index].cate_id).then(
          (res) => {
            this.objOther = res.data.payload;
            this.multFunction(this.tableData[index].unit_name, index);
          }
        );
      }
    },
    multFunction(val, index) {
      this.tableData[index].charging_value = this.objOther[val];
      this.tableData[index].total_amount =
        val != "FIXED"
          ? parseFloat(
            (this.objOther[val] * this.tableData[index].price).toFixed(4)
          )
          : parseFloat(this.tableData[index].price.toFixed(4));
    },
    preview(src) {
      window.open(src, "_blank");
    },
    handleUpload(file) {
      this.upload(file, 1);
      return false;
    },
    upload(file) {
      let formData = new FormData();
      formData.append("file", file);
      updateBill(formData).then((res) => {
        if (!res.data.status) {
          this.alertMes(res);
          return;
        }
        this.filePath = res.data.payload.src;
      });
    },
    exportExc() {
      this.loading = true;
      exportBillDetails(this.row.airway_number).then((res) => {
        this.loading = false;
        if (res.data.status) {
          window.open(this.$globalUrl + res.data.payload.path);
        } else {
          this.$Message["error"]({
            background: true,
            content: res.data.msg,
            duration: 5,
          });
        }
      });
    },
    selectTable(val) {
      this.selectArr = [];
      val.some((item) => {
        this.selectArr.push(item.id);
      });
    },
    getOtherList() {
      getDoubleContents().then((res) => {
        this.conmanyList = res.data.payload;
      });
      getItem().then((res) => {
        this.itemList = res.data.payload;
      });
      fileRead().then((res) => {
        this.filePath = res.data.payload;
      });
      getB2bCategory(this.row.airway_number).then((res) => {
        this.categoryList = res.data.payload;
      });
      getChargingType({ airway_number: this.row.airway_number }).then((res) => {
        this.chargingList = res.data.payload;
      });
      getDefList(
        this.row.airway_number,
        this.row.target_type == 2 ? { target: 2 } : {}
      ).then((res) => {
        this.defList = res.data.payload;
        this.defId = this.defList.length > 0 ? this.defList[0].value : 0;
        this.SearchSubmit();
      });
      // 读取成本信息
      getSystemCosting(this.row.airway_number).then(r => {
        this.costingTips = r.data.payload.tips || ''
        this.$forceUpdate()
      })
    },
    SearchSubmit() {
      let data = {
        airway_number: this.row.airway_number,
        id: this.defId,
        target_type: this.row.target_type,
      };
      this.loading = true;
      getFinanceData(data).then((res) => {
        this.loading = false;
        if (!res.data.status) {
          this.alertMes(res);
          return;
        }
        let data = res.data.payload;
        this.totalData = data.total;
        this.tableData = data.finance;
        this.finance_remarks = data.finance_remarks;
        // let pushData = {
        //   cate_id: "",
        //   expense_item: 0,
        //   price: 0,
        //   remarks: "",
        //   total_amount: "",
        //   currency: ""
        // };
        // this.tableData.unshift(pushData);
      });
      // getDoubleBill(this.row.airway_number)
      //   .then(res => {
      //     if (!res.data.status) {
      //       this.loading = false;
      //       this.alertMes(res);
      //       return;
      //     }
      //     let data = res.data.payload;
      //     this.totalData = res.data.payload.TOTAL;
      //     this.tableData = data[this.type];
      //     let pushData = {
      //       cate_id: "",
      //       expense_item: 0,
      //       price: 0,
      //       remarks: "",
      //       total_amount: "",
      //       currency: ""
      //     };
      //     this.tableData.unshift(pushData);
      //     // getBillCurrency(this.row.airway_number).then(res => {
      //     //   this.bindCurrency = res.data.payload;
      //     // });
      //     this.loading = false;
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    alertMes(res) {
      if (res.data.status) {
        this.$Message["success"]({
          background: true,
          content: res.data.msg,
        });
        this.SearchSubmit();
        this.$parent.$parent.$page.getList();
        this.$parent.$parent.$page.closeLoading();
      } else {
        this.$Message["error"]({
          background: true,
          content: res.data.msg,
          duration: 5,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ivu-table-header thead tr th.text-left {
  text-align: center;
}

.ivu-form-inline .ivu-form-item {
  margin-bottom: 0;
}

.total-bill {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e8eaec;
  border-top: 0;
  font-weight: bold;
  padding: 0 10px;

  .label {
    display: flex;
    align-items: center;
    justify-content: center;

    .titel {
      margin-left: 10px;

      span {
        color: red;
        margin: 0 5px;
      }
    }
  }
}
</style>
